import { motion } from "framer-motion";
import { T } from "../data/content";
import { useLang } from "../context/LangContext";
import { useSiteData } from "../context/SiteDataContext";

export const Gallery = () => {
  const { tr } = useLang();
  const { gallery } = useSiteData();
  return (
    <section id="gallery" className="relative bg-[#0C0806] py-24 lg:py-36" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 flex items-end justify-between">
          <div>
            <div className="mb-5 flex items-center gap-3">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-[10px] uppercase tracking-[0.4em] text-[#D4AF37]">{tr(T.gallery.label)}</span>
            </div>
            <h2 className="font-serif text-5xl tracking-tight text-[#F5ECDA] md:text-6xl">{tr(T.gallery.title)}</h2>
          </div>
        </div>

        <div className="columns-2 gap-3 md:columns-3 md:gap-4 lg:columns-4 [column-fill:_balance]">
          {gallery.map((g, i) => (
            <motion.figure
              key={g.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group relative mb-3 break-inside-avoid overflow-hidden rounded-sm border border-white/5 md:mb-4"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.url}
                alt={`Slaly hairstyle by Essi ${i + 1}`}
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
